<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg8 sm10 xs12>
            <v-card pa-0> 
              <v-toolbar dark flat dense cad color="primary">
                <v-toolbar-title class="subheading">Form User</v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="form-btn">
                    <v-btn v-if="!isUpdate" @click="save(isUpdate)" v-bind:loading="loading" outline>Create</v-btn>
                    <v-btn v-else @click="save(isUpdate)"  v-bind:loading="loading" outline>Update</v-btn>                                                                                        
                </div>
                <v-menu bottom left v-if="isUpdate">
                  <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                  <v-list>                                                    
                    <v-list-tile>
                      <v-list-tile-title @click="remove()">delete</v-list-tile-title>                  
                    </v-list-tile>
                  </v-list>
                </v-menu>  
              </v-toolbar>
              <v-card-text class="">
                <v-layout row wrap>
                  <v-flex lg6 sm6>  
                    <v-form>                      
                      <v-text-field box
                          label="Username"
                          name="username"                              
                          v-model="formModel.username"
                          v-validate="'required'"
                          data-vv-name="username"  
                          @keyup="setEmail()"
                          :error-messages="errors.collect('username')"  
                          required
                      ></v-text-field>

                      <v-text-field box
                        v-validate="'required|email'"
                        v-model="formModel.email"
                        :error-messages="errors.collect('email')"
                        label="E-mail"
                        data-vv-name="email"
                        required
                      ></v-text-field>  

                      <v-text-field          
                        box                    
                        v-model="formModel.password"
                        :error-messages="errors.collect('password')"
                        label="Password"
                        data-vv-name="password"
                        type="password"
                        required
                      ></v-text-field>                         

                      <v-text-field box
                          label="Fullname"
                          name="name"                              
                          v-model="formModel.nama"
                          v-validate="'required'"
                          data-vv-name="nama"     
                          :error-messages="errors.collect('nama')"  
                          required
                      ></v-text-field>

                      <v-text-field box
                          label="Phone Number"
                          name="phone"                              
                          v-model="formModel.telepon"
                          v-validate="'required'"
                          data-vv-name="phone"     
                          :error-messages="errors.collect('telepon')"  
                          required
                      ></v-text-field>


                      <v-text-field
                        label="Jabatan"                                      
                        v-model="formModel.jabatan"
                        v-validate="'required'"
                        data-vv-name="jabatan"     
                        box
                        :error-messages="errors.collect('jabatan')"  
                        required
                      ></v-text-field>


                    </v-form>  
                  </v-flex>    
                  <v-flex lg6 sm6>  
                    <v-radio-group label="Tingkat :" v-model="formModel.tingkat_id" row v-validate="'required'" data-vv-name="tingkat_id" :error-messages="errors.collect('tingkat_id')">
                      <v-radio label="SD"  :value="1"></v-radio>
                      <v-radio label="SMP" :value="2"></v-radio>
                      <v-radio label="MA" :value="3"></v-radio>
                    </v-radio-group>
                    <v-radio-group label="Jurusan :" v-model="formModel.jurusan_id" row  v-if="formModel.tingkat_id === 3" v-validate="'required'" data-vv-name="jurusan_id" :error-messages="errors.collect('jurusan_id')">
                      <v-radio label="IPA"  :value="4"></v-radio>
                      <v-radio label="IPS" :value="5"></v-radio>
                      <v-radio label="AGAMA" :value="6"></v-radio>
                    </v-radio-group>  
                    
                    <v-switch 
                      v-bind:label="formModel.status === 10 ? 'Status Active' : 'Status Inactive'" 
                      v-bind:true-value="10"
                      v-bind:false-value="0"                   
                      v-model="formModel.status">                      
                    </v-switch>
                  </v-flex>
                </v-layout>
              </v-card-text>       
            </v-card>          
          </v-flex>
        </v-layout>        
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Permission from '@/apps/admin/models/User';    
import direct     from '@/util/directives';

var model = new Permission();

export default {
    directives : direct, 
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({        
        isUpdate:false,
        swithStatus: false,
        formModel: {
          id      : null,  
          email    : null,          
          username : null,
          password : null,          
          nama : null,
          jabatan : null,
          telepon : null,          
          status : 10,
          tingkat_id : null,
          jurusan_id : null,
        },
        statusSwitch :false,
        //countries: Countries,
        loading : false,        
    }),    
    watch:{      
      
    },
    created () {
      /*this.$watch(['formModel','trial'].join('.'), (val)=>{ if(val){
          this.$refs.date.save(val);
          this.formModel.dateV = this.$moment(val).format('DD-MM-YYYY');
      }});*/
    },    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true; this.loading= true;
                model.one({id : this.$route.query.id }).then(data => {                      
                    Object.assign(this.formModel, data === null ? {}:data);
                    this.loading=false;
                });                                               
            }            
            this.$validator.localize('en', this.dictionary);       
        },
        
        setEmail(){
            if(!this.isUpdate){
                this.formModel.email = this.formModel.username + '@gmail.com';
            }
        },                
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            if( !this.errors.any() ) { this.loading=true;
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){  
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.push({path:'/rbac/user', query:{id:res.data.id}});                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
                this.loading=false;
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
             
        remove(){
          this.$swal({
            title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',
            showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
          }).then((result) => {                 
              if (result.value) { 
                model.delete(this.formModel).then( res => {
                  if(res.status === 200){  
                      this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                          
                      this.$router.push({path:'/user'});
                  } else {
                      var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                      var text  = res.statusText ? res.statusText:
                          'Something happened in setting up the request that triggered an Error.'; 
                      this.$swal({type: 'error', title: title, text: text});                                        
                  }
                });
              }
          });    
        },                    
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },                       
    }
}
</script>
